import { FetchOptions, FetchError } from "ofetch"
import { RefreshTokenRequest, RefreshTokenResponse } from "~/stores/user"
import { ApiResponse } from "~/types/api"

export default () => {
	const runtimeConfig = useRuntimeConfig()
	const userApiUrl = useUserApiUrl()
	const userStore = useUserStore()

	return {
		onRequest: (context) => {
			const token = userStore.token
			if (token) {
				context.options.headers = { ...context.options.headers, Token: token }
			}
			if (!(context.options.body instanceof FormData)) {
				context.options.headers = {
					...context.options.headers,
					"Content-Type": "application/json"
				}
			}
			context.options.baseURL = runtimeConfig.baseUrl || runtimeConfig.public.baseUrl
			if (userStore.token && !userStore.refreshToken) {
				userStore.setToken(null)
			} else if (!userStore.token && userStore.refreshToken) {
				userStore.setRefreshToken(null)
			}
		},
		onResponse: async (context) => {
			if (context.response.ok) {
				const data = context.response?._data as ApiResponse
				userStore.time = data?.time
				userStore.elapsedTime = 0
				return
			}
			const refreshToken = userStore.refreshToken
			let token = userStore.token
			if (401 === context.response.status && refreshToken && token) {
				try {
					const r = await $fetch<RefreshTokenResponse>(userApiUrl.RefreshToken.url(), {
						baseURL: runtimeConfig.baseUrl || runtimeConfig.public.baseUrl,
						method: userApiUrl.RefreshToken.method,
						headers: {
							Token: token
						},
						body: {
							refresh_token: refreshToken
						} as RefreshTokenRequest
					})
					token = r.data.token
					userStore.setToken(token)
					userStore.setRefreshToken(refreshToken)
				} catch (error: any) {
					if (error instanceof FetchError) {
						userStore.user = null
						userStore.setToken(null)
						userStore.setRefreshToken(null)
					}
					error.response && (context.response = error.response)
					return
				}
				try {
					context.response = await $fetch.raw<any>(context.request, {
						...(context.options as any),
						headers: {
							...context.options.headers,
							Token: token
						}
					})
				} catch (error: any) {
					error.response && (context.response = error.response)
				}
			}
		}
	} as FetchOptions
}
